import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent } from "@angular/common/http";
import { BaseGridService } from "app/shared/base-grid.service";
import { Observable, map, tap } from "rxjs";
import { ConfigEnvService } from "app/shared/configEnvService";

@Injectable({
  providedIn: "root",
})
export class LoginService extends BaseGridService {
  constructor(public http: HttpClient, envService: ConfigEnvService) {
    super(http, envService, "api/User");
  }

  login(username: string, password: string) {
    return this.http
      .post<any>(`${this.baseUrl}${this.controller}/Login`, {
        username: username,
        password: password,
      }, { withCredentials: true })
      .pipe(
        map((user) => {
          if (user && user.token) {
            localStorage.setItem("currentUser", JSON.stringify(user));
          }

          return user;
        })
      );
  }

  logout() {
    return this.http.post(`${this.baseUrl}${this.controller}/Logout`, {}, { withCredentials: true })
      .pipe(tap(() => localStorage.removeItem("currentUser")));
  }

  session() {
    return this.http.get<any>(`${this.baseUrl}${this.controller}/Session`, { withCredentials: true })
      .pipe(tap(user => localStorage.setItem("currentUser", JSON.stringify(user))));
  }
}
